import React, { FC } from 'react';
import { SLOT_TOP } from 'components/ads/ad-slot/ad-defs';
import AdSlotPlaceholderGAM from 'components/ads/ad-slot-placeholder-gam';
import AdSlot from 'components/ads/ad-slot';
import classNames from 'classnames';

import './ad-slot-top.scss';

interface AdSlotTopProps {
    isMobile?: boolean;
}

const AdSlotTop: FC<AdSlotTopProps> = ({ isMobile = false }) => (
    <AdSlotPlaceholderGAM
        className={classNames('ad-slot-top', {
            'ad-slot-top--mobile': isMobile
        })}
    >
        <AdSlot
            className="creation-top"
            name={SLOT_TOP}
        />
    </AdSlotPlaceholderGAM>
);

export default AdSlotTop;
